import * as actionTypes from './actionTypes';
import axios from "axios";
import api from '../../utilities/api';
import { getMessage } from '../../utilities/getMessage';

export const getAgreements=(token)=>async dispatch=>{
    dispatch({
        type:actionTypes.GET_AGREEMENTS_START
    })
    const options={
        url:`${api}/agreements`,
        method:'GET',
        headers:{
            Authorization:`Bearer ${token}`
        },
        data:{}
    }
    await axios(options)
            .then(response=>dispatch({
                type:actionTypes.GET_AGREEMENTS_SUCCESS,
                payload:response.data
            }))
            .catch(error=>dispatch({
                type:actionTypes.GET_AGREEMENTS_FAIL,
                payload:getMessage(error)
            }))
}